<template>
  <div class="row Consumer">
    <div class="col">
      <div class="Title">取餐方式</div>
      <div class="consumerList">
        <input type="radio" class="form-check-input" value="外帶" v-show="Global.isGuest === false && Takeaway" v-model="this.$parent.$data.diningModel" :disabled="!Takeaway || orderHandler == 0">
        <span class="diningModel" @click="setDiningModel('外帶')" v-show="Global.isGuest === false && Takeaway">外帶自取</span>
        <div class="takeaway-group"  v-show="diningModel == '外帶' && Global.isGuest === false && Takeaway">
          <div class="shopAddressTip">自取店家地址</div>
          <div class="shopAddress">{{shopAddress}}</div>
        </div>
        <br>
        <input type="radio" class="form-check-input" value="內用" v-model="this.$parent.$data.diningModel" v-show="Inside" :disabled="!Inside || orderHandler == 0">
        <span class="diningModel" @click="setDiningModel('內用')" v-show="Inside">內用</span>
        <div class="input-group" v-show="diningModel == '內用' && Inside">
          <span class="tableNumber">桌號：</span>
          <input type="text" class="form-control tableNumber" v-model="this.$parent.$data.tableNumber" placeholder="桌號請填四個字以內" :disabled="orderHandler == 0">
        </div>
        <div class="input-group" v-show="diningModel == '內用' && Inside">
          <span class="insideCaptcha">內用驗證碼：</span>
          <input type="text" class="form-control insideCaptcha" :class="{ 'Success': insideCaptchaRight == true, 'Error': insideCaptchaRight == false } "  v-model="this.$parent.$data.insideCaptcha" @change="changeInsideCaptcha()" placeholder="請輸入內用驗證碼" :disabled="orderHandler == 0">
        </div>
        <br>
        <input type="radio" class="form-check-input" value="外送" v-show="Global.isGuest === false && Delivery" v-model="this.$parent.$data.diningModel" @click="setDiningModel('外送')" :disabled="!Delivery || orderHandler == 0">
        <span class="diningModel" @click="setDiningModel('外送')" v-show="Global.isGuest === false && Delivery">外送<span v-if="Shop?.deliveryPrice">（訂單價格需達到 ${{Shop?.deliveryPrice}}）</span></span>
        <select class="form-select" v-show="diningModel == '外送' && Global.isGuest === false && Delivery" v-model="this.$parent.$data.Address" @change="addAddress()" :disabled="orderHandler == 0">
          <option :value="User?.Address" v-show="User?.Address" selected>{{User?.Address}}</option>
          <option :value="Address" v-show="Address">{{Address}}</option>
          <option value="addAddress">編輯本次外送地址</option>
        </select>
        <br>
        <div class="input-group" v-if="diningModel != '內用'">
          <span class="takeMealTime">預計取餐時間：</span>
          <span class="AMorPM" v-if="this.$parent.$data.Time < '12:00'">AM</span>
          <span class="AMorPM" v-else>PM</span>
          <input type="time" class="form-control takeMealTime" v-model="this.$parent.$data.Time" :disabled="orderHandler == 0">
        </div>
        <div class="businessHours">
          營業時間：{{Shop?.openingTime.substring(0, 5)}} ~ {{Shop?.closingTime.substring(0, 5)}}，備餐時間 {{Shop?.mealInterval}} 分鐘
          <div v-show="diningModel == '外送'">送餐時間 {{Shop?.deliveryTime}} 分鐘</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'
export default {
  name: "Consumer",
  props: {
    diningModel: String,    // 取餐方式
    shopAddress: String,    // 店家地址
    orderHandler: Number,   // 訂單處理狀態
  },
  data() {
    return {
      Global: Global,
      User: Global.User, // 消費者資料
      Shop: Global.Shop, // 店家資料
      Takeaway: false, // 能否外帶
      Inside: false, // 能否內用
      Delivery: false, // 能否外送
      Address: null, // 外送地址
      insideCaptchaRight: null, // 內用驗證碼判斷是否正確
    }
  },
  methods: {
    /* 初始化 */
    init: function() {
      if (!this.$data.Shop?.orderModel) return false
      let orderModel = this.$data.Shop.orderModel
      if (orderModel >= 4) {
        this.$data.Delivery = true
        orderModel -= 4
      }
      if (orderModel >= 2) {
        this.$data.Takeaway = true
        orderModel -= 2
      }
      if (orderModel >= 1) {
        this.$data.Inside = true
        orderModel -= 1
      }
      if (Global.isGuest !== false) {
        this.$data.Delivery = false
        this.$data.Takeaway = false
      }
      flatpickr("#time-picker", { enableTime: true, noCalendar: true, dateFormat: "H:i", time_24hr: true })
    },
    /* 消費者輸入新的外送地址 */
    addAddress: function() {
      let Address = prompt(Global.MESSAGE.CART.DELIVERY_PROMPT)
      if (Address) {
        this.$data.Address = Address
        this.$parent.$data.Address = this.$data.Address
      } else {
        this.$parent.$data.diningModel = null
        console.log(99, this.$parent.$data.diningModel)
      }
    },
    /* 檢查內用驗證碼是否輸入正確 */
    changeInsideCaptcha: function() {
      if (this.$parent.$data.insideCaptcha == null) return false
      this.$data.insideCaptchaRight = this.$parent.$data.insideCaptcha == this.$parent.$data.Shop.insideCaptcha ? true : false
    },
    /* 選擇取餐方式 */
    setDiningModel: async function(diningModel) {
      if (diningModel == "內用" && !this.$data.Inside) {
        return false
      }
      /* 遊客點選內用時，前三次顯示提醒（僅內用、外帶需註冊） */
      if (diningModel === "內用" && Global.isGuest !== false) {
        const storageKey = 'guestDineInTipCount'
        let count = parseInt(localStorage.getItem(storageKey) || '0', 10)
        if (count < 3) {
          await swal.alertInfo('提醒您：遊客身份僅內用功能！如需外帶自取，請先註冊會員！')
          localStorage.setItem(storageKey, String(count + 1))
        }
      }
      if (diningModel == "外帶" && !this.$data.Takeaway) {
        return false
      } else if (diningModel == "外送" && !this.$data.Delivery) {
        return false
      } else if (diningModel == "外送") {
        /* 店家沒有設定外送價格限制，拒絕外送 */
        if (this.$data.Shop.deliveryPrice == null) return false
        /* 訂單價格小於外送價格，拒絕外送 */
        let discountPrice = this.$parent.$data.discountPrice == null ? this.$parent.Total : this.$parent.$data.discountPrice
        if (discountPrice < this.$data.Shop.deliveryPrice) {
          this.$parent.$data.diningModel = null
          swal.alertError(Global.MESSAGE.CART.DELIVERY_PRICE_NOT_REACH_STANDARD)
          return false
        }
        /* 若消費者沒有外送地址，則讓他填 */
        if (this.$parent.$data.Address == 'addAddress') this.addAddress()
      }
      this.$parent.$data.diningModel = diningModel
      if (this.$parent.$data.diningModel == "外送" && this.$parent.$data.Address == 'addAddress') this.$parent.$data.diningModel = null
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.Consumer {
  margin: auto auto 20px auto !important;
  > .col {
    > .Title {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 900;
      color: #87CEFAAA;
      text-shadow: 1px 1px 0 #000000;
    }
    > .consumerList {
      padding: 25px 20px 5px 20px;
      border-radius: 8px;
      background: #f8f8f8;
      > .diningModel {
        display: inline-block;
        margin: auto auto 10px 10px;
        font-weight: bold;
        font-size: 16px;
      }
      > .takeaway-group {
        position: relative;
        padding-top: 5px;
        > .shopAddressTip {
          position: absolute;
          line-height: 1;
          top: -2px;
          left: 20px;
          font-size: 15px;
          color: #969696;
          background-color: #f8f8f8;
          padding: 0px 3px;
        }
        > .shopAddress {
          border: 1px solid #dedede;
          border-radius: 8px;
          padding: 12px 16px;
          width: 100%;
        }
      }

      > .input-group {
        > span.tableNumber {
          margin-right: 10px;
          width: 100px;
          font-size: 16px;
          font-weight: bold;
          line-height: 38px;
          text-align: right;
        }
        > input.tableNumber {
          flex: none;
          width: 180px;
          border-radius: 0.25rem !important;
        }
        > span.insideCaptcha {
          margin-top: 10px;
          margin-right: 10px;
          width: 100px;
          font-size: 16px;
          font-weight: bold;
          line-height: 38px;
          text-align: right;
        }
        > input.insideCaptcha {
          margin-top: 10px;
          flex: none;
          width: 180px;
          border-radius: 0.25rem !important;
        }
        > input.insideCaptcha.Success {
          border: 2px solid green;
        }
        > input.insideCaptcha.Error {
          border: 2px solid red;
        }
        > span.takeMealTime {
          display: inline-block;
          margin-top: 20px;
          font-weight: bold;
          font-size: 16px;
          line-height: 38px;
        }
        > input.takeMealTime {
          margin-top: 20px;
          margin-left: 10px !important;
          flex: none;
          width: 150px;
        }
        .AMorPM {
          display: inline;
          margin-top: 20px;
          margin-left: 5px !important;
          line-height: 38px;
          font-weight: bold;
        }
      }
      > .businessHours {
        margin-top: 5px;
        font-size: 14px;
        font-weight: bold;
        text-align: right;
      }
    }
  }
}
@media (max-width: 900px) {
  .Consumer {
    .consumerList {
      select {
        width: 100%;
      }
      input.takeMealTime {
        width: 185px;
      }
    }
  }
}
</style>